import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import SegmentedControl from '@jimmyboys/liita-ui/dist/components/SegmentedControl'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'

import ProtocolsController from './ProcessProtocols/ProtocolsController'

import styles from './ProtocolsController.module.sass'
import PresetProtocolsController from './PresetProtocols/PresetProtocolsController'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'

const SelectedController = (selectedTab) => {
	switch (selectedTab) {
		case 'processProtocols':
			return <ProtocolsController />
		case 'presetProtocols':
			return <PresetProtocolsController />
		default:
			return <ProtocolsController />
	}
}

const ProtocolsAreaController = () => {
	const { i18n } = useGlobal()
	const location = useLocation()
	const [queryParams, , setQueryParams] = useQueryParams(location)

	const tabs = [
		{
			id: 'processProtocols',
			text: i18n`By Process`,
		},
		{
			id: 'presetProtocols',
			text: i18n`Preset`,
		},
	]

	const isProcessProtocolsTab = queryParams.selectedTab === 'processProtocols'

	return (
		<>
			<Widget paddings={['small', 'normal', '']} applyMaxWidth>
				<HStack
					className={styles['header-options']}
					align='center'
					justify='space-between'
					gap='xsmall'
					flex={[
						[1, 1],
						[1, 1],
					]}
				>
					<div>
						<small>
							<strong>
								{isProcessProtocolsTab
									? i18n`Process Protocols`
									: i18n`Preset Protocols`}
							</strong>
						</small>
					</div>
					<SegmentedControl
						className={styles['notes-segment-control']}
						selectedTab={queryParams.selectedTab}
						onSelect={(e) => {
							setQueryParams({ selectedTab: e.id })
						}}
						tabs={tabs}
					/>
				</HStack>
			</Widget>

			{SelectedController(queryParams.selectedTab)}
		</>
	)
}

export default ProtocolsAreaController
